import format from '@thoughtspot/string-format';
import _ from 'lodash';
export function assign(expression, ...args) {
    if (typeof _.first(args) === 'object') {
        return format(expression, ...args);
    }
    return format(expression, '', ...args);
}
export function capitalize(word, all = false) {
    let lastResponded;
    return word.toLowerCase().replace(all ? /[^']/g : /^\S/, lower => {
        const upper = lower.toUpperCase();
        const result = lastResponded ? lower : upper;
        lastResponded = upper !== lower;
        return result;
    });
}
export function getTokenPositionFromIndex(text, position, separator = ' ') {
    let currentPos = text.indexOf(separator);
    let currentLength = 0;
    let tokenIdx = 0;
    while (currentPos < position && currentPos >= 0) {
        currentLength = currentPos;
        tokenIdx++;
        currentPos = text.indexOf(separator, currentPos + 1);
    }
    return {
        tokenIdx,
        tokenOffset: position - currentLength,
    };
}
//# sourceMappingURL=string-util.js.map